// removed by extract-text-webpack-plugin
module.exports = {"ImportDataTable":"ImportDataTable","TableWrapper":"TableWrapper","errorNotice":"errorNotice","required":"required","hasError":"hasError","trIndex":"trIndex"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ImportStudent/ImportDataTable.scss
// module id = t2fR
// module chunks = 0